import { render, staticRenderFns } from "./PlayerPollingAndSockets.vue?vue&type=template&id=ad7acbae&scoped=true&"
import script from "./PlayerPollingAndSockets.vue?vue&type=script&lang=js&"
export * from "./PlayerPollingAndSockets.vue?vue&type=script&lang=js&"
import style0 from "./PlayerPollingAndSockets.vue?vue&type=style&index=0&id=ad7acbae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad7acbae",
  null
  
)

export default component.exports